<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container bg-light p-5 rounded shadow">
      <button class="btn btn-link" @click="$router.go(-1)">
        <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
      </button>
      <b-table
        responsive=""
        :fields="fields"
        :items="forms"
        v-if="!is_add_edit"
      >
        <template v-slot:cell(actions)="data">
          <div class="text-right d-flex flex-nowrap">
            <button
              class="btn px-1 btn-sm btn-link text-info"
              @click="edit(data.index)"
            >
              <i class="fa fa-edit"></i>
            </button>
            <button
              class="btn px-1 btn-sm btn-link text-danger"
              @click="remove(data.item.id)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </template>
      </b-table>
      <div class="builder" v-else>
        <div class="form-group">
          <label for="type-select">{{
            $t("message.admin.sad_builder_type")
          }}</label>
          <select
            id="type-select"
            class="form-control"
            v-model="current_form.type"
          >
            <option value="im">IM</option>
          </select>
        </div>
        <hr />
        <div
          v-for="(item, index) in current_form.data.items"
          :key="'sbrow-container' + index"
          class="border- p-3 mb-3"
          :data-index="index"
        >
          <!-- <draggable v-model="item.items"
            v-for="(ritem, rindex) in item.items"
            
          > -->
          <sb-row
            @reorder_columns="reorder_columns($event, index)"
            @remove_element="remove_element($event, index)"
            @add_column="add_column(index)"
            @remove_column="remove_column($event, index)"
            @add_element="$event => add_element($event, index.toString())"
            @update_column="update_column($event, index)"
            @column_added="column_added($event, index)"
            @column_removed="column_removed($event, index)"
            @column_moved="column_moved($event, index)"
            @element_added="element_added($event, index)"
            @element_removed="element_removed($event, index)"
            @element_moved="element_moved($event, index)"
            @element_changed="element_changed($event, index)"
            :key="'sbrow-' + Math.random()"
            :items="item.items"
            :row_index="index.toString()"
          ></sb-row>
          <!-- </draggable> -->
        </div>
        <button class="btn btn-light" v-if="is_add_edit" @click="add_row">Add row</button>
        <hr>
        <button class="btn btn-success" @click="create()" v-if="is_new">
          {{ $t("message.add") }}
        </button>
        <button class="btn btn-success" @click="save()" v-else>
          {{ $t("message.save") }}
        </button>
        <button class="btn btn-light float-right" @click="cancel()">
          {{ $t("message.cancel") }}
        </button>
      </div>
      <button class="btn btn-light" @click="add()" v-if="!is_add_edit">
        {{ $t("message.add") }}
      </button>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  data() {
    return {
      forms: [],
      is_add_edit: false,
      is_new: false,
      current_form: {
        type: "",
        data: "",
      },
      fields: [
        {
          key: "form_type",
          label: this.$t("message.admin.sad_builder_type"),
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.load();
  },
  methods: {
    column_added(payload, index) {
      this.current_form.data.items[index].items.splice(
        payload.newIndex,
        0,
        payload.element,
      );
    },
    column_removed(payload, index) {
      this.current_form.data.items[index].items.splice(payload.newIndex, 1);
    },
    column_moved(payload, index) {
      this.current_form.data.items[index].items.splice(
        payload.element_index,
        0,
        this.current_form.data.items[index].items.splice(
          payload.element_old_index,
          1,
        )[0],
      );
    },
    element_added(payload, index) {
      this.current_form.data.items[index].items[payload.index].items.splice(
        payload.newIndex,
        0,
        payload.element,
      );
    },
    element_removed(payload, index, row_index) {
      this.current_form.data.items[index].items[payload.index].items.splice(
        payload.newIndex,
        1,
      );
    },
    element_moved(payload, index, row_index) {
      this.current_form.data.items[index].items[payload.index].items.splice(
        payload.element_index,
        0,
        this.current_form.data.items[index].items[payload.index].items.splice(
          payload.element_old_index,
          1,
        )[0],
      );
    },
    element_changed(payload, index) {
      this.$set(
        this.current_form.data.items[index].items[payload.index].items,
        payload.element_index,
        payload.value,
      );
    },

    update_column(payload, index) {
      this.$set(
        this.current_form.data.items[index].items[payload.index],
        payload.type,
        payload.value,
      );
    },
    reorder_columns(payload, index, row_index) {
      this.$set(
        this.current_form.data.items[index].items[row_index],
        "items",
        payload.value,
      );
    },
    remove_element(payload, index, row_index) {
      this.current_form.data.items[index].items[row_index].items[
        payload.index
      ].items.splice(payload.element_index, 1);
    },
    add_column(index, row_index) {
      console.log(index, row_index)
      this.current_form.data.items[index].items.push({
        classes: "col-md-12",
        id: "",
        type: "col",
        items: [],
      });
    },
    remove_column(payload, index, row_index) {
      this.current_form.data.items[index].items[row_index].items.splice(
        payload,
        1,
      );
    },
    add_element(payload, index, row_index) {
      this.current_form.data.items[index].items[payload].items.push({
        type: "",
        classes: "col-md-12",
        id: "",
        model: "",
        is_filled: true,
        is_required: false,
        options: {},
        label: "",
      });
    },
    add_row() {
      this.current_form.data.items.push({
        items: [
          {
            type: "row",
            items: [],
          },
        ],
      });
    },
    load() {
      axios
        .get(window.base + "/document/load_sad_templates")
        .then((response) => {
          this.forms = response.data.map((item) => {
            item.form_data = JSON.parse(item.form_data);
            return item;
          });
        });
    },
    cancel() {
      this.is_add_edit = false;
      this.is_new = false;
    },
    add() {
      this.is_add_edit = true;
      this.is_new = true;
      this.current_form = {
        type: "",
        data: {
          items: [],
          // items: [
          //   {
          //     //represents row
          //     id: "row-1",
          //     items: [
          //       {
          //         type: "col",
          //         id: "col-1",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             id: "h-0",
          //             label: "message.contracts.sad_line_2",
          //             type: "h",
          //             classes: "col-12",
          //             is_filled: false,
          //           },
          //           {
          //             id: "gtd_g022i",
          //             classes: "col-md-12",
          //             type: "text",
          //             model: "g022i",
          //             label: "message.contracts.gtd_g022i",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               maxlength: 200,
          //             },
          //           },
          //           {
          //             id: "gtd_g023i",
          //             classes: "col-md-12",
          //             type: "address",
          //             model: "g023i",
          //             label: "message.contracts.gtd_g023i",
          //             is_filled: true,
          //             is_required: false,
          //             options: {},
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         id: "col-2",
          //         classes: "col-md-3 border p-2",
          //         items: [
          //           {
          //             id: "h-1",
          //             label: "message.contracts.sad_line_1_title",
          //             type: "h",
          //             classes: "col-12",
          //             is_filled: false,
          //           },
          //           {
          //             type: "div",
          //             classes: "d-flex px-3 ch-px-3",
          //             items: [
          //               {
          //                 id: "gtd_g011",
          //                 classes: "col-md-4 px-md-0",
          //                 type: "text",
          //                 model: "g011",
          //                 label: "",
          //                 is_filled: true,
          //                 is_required: false,
          //                 options: {
          //                   maxlength: 2,
          //                   noformlabel: true,
          //                   description: "message.contracts.gtd_g011",
          //                   inputclass:
          //                     "px-0 text-center rounded-0 rounded-left border-right-0",
          //                   labelclass: "  two-line px-2 mt-2 ",
          //                 },
          //               },
          //               {
          //                 id: "gtd_g012",
          //                 classes: "col-md-4 px-md-0",
          //                 type: "text",
          //                 model: "g012",
          //                 label: "",
          //                 is_filled: true,
          //                 is_required: false,
          //                 options: {
          //                   maxlength: 2,
          //                   noformlabel: true,
          //                   description: "message.contracts.gtd_g012",
          //                   inputclass: "px-0 text-center rounded-0",
          //                   labelclass: "  two-line px-2 mt-2 ",
          //                 },
          //               },
          //               {
          //                 id: "gtd_g012_1",
          //                 classes: "col-md-4 px-md-0",
          //                 type: "text",
          //                 model: "g012_1",
          //                 label: "",
          //                 is_filled: true,
          //                 is_required: false,
          //                 options: {
          //                   maxlength: 2,
          //                   noformlabel: true,
          //                   description: "message.contracts.gtd_g012_1",
          //                   inputclass:
          //                     "px-0 text-center rounded-0 rounded-right border-left-0",
          //                   labelclass: "  two-line px-2 mt-2 ",
          //                 },
          //               },
          //             ],
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         id: "col-3",
          //         classes: "col-md-3",
          //         items: [
          //           {
          //             id: "h-2",
          //             label: "message.contracts.sad_lina_a",
          //             type: "h",
          //             classes: "col-12",
          //             is_filled: false,
          //           },
          //           {
          //             id: "gtd_ga",
          //             classes: "col-md-12",
          //             type: "text",
          //             model: "ga",
          //             label: "message.contracts.gtd_ga",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               maxlength: 14,
          //               labelclass: "two-line",
          //             },
          //           },
          //           {
          //             id: "gtd_g542",
          //             classes: "col-md-12",
          //             type: "datepicker",
          //             model: "g542",
          //             label: "message.contracts.gtd_g542",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               maxlength: 14,
          //               labelclass: "two-line",
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //     classes: "row",
          //   },
          //   {
          //     type: "row",
          //     classes: "row",
          //     items: [
          //       {
          //         type: "col",
          //         classes: "col-md-12",
          //         items: [
          //           {
          //             type: "h",
          //             classes: "col-md-12",
          //             label: "message.contracts.sad_line_3",
          //           },
          //           {
          //             type: "text",
          //             classes: "col-md-12",
          //             model: "sad_line_a",
          //             label: "message.contracts.sad_line_3_value",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               readonly: true,
          //               autoload: `(column, index, product)=>{
					// 											return Math.ceil((this.gtd.g05-1)/3)
					// 										}`,
          //             },
          //           },
          //           {
          //             type: "h",
          //             classes: "col-md-12",
          //             label: "message.contracts.sad_line_4",
          //           },
          //           {
          //             type: "text",
          //             classes: "col-md-5",
          //             model: "g041",
          //             id: "g041",
          //             label: "message.contracts.gtd_g041",
          //             is_filled: true,
          //             is_required: false,
          //             options: {},
          //           },
          //           {
          //             type: "div",
          //             classes: "col-md-2 text-center",
          //             model: "g042",
          //             label: "/",
          //             options: {},
          //             items: [],
          //           },
          //           {
          //             type: "text",
          //             classes: "col-md-5",
          //             model: "g042",
          //             id: "g042",
          //             label: "message.contracts.gtd_g042",
          //             is_filled: true,
          //             is_required: false,
          //             options: {},
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   {
          //     id: "row-010",
          //     items: [
          //       {
          //         type: "col",
          //         id: "col-03",
          //         classes: "col-md-6 mt-3",
          //         items: [
          //           {
          //             type: "h",
          //             classes: "col-md-6",
          //             label: "message.contracts.sad_line_5",
          //           },
          //           {
          //             type: "h",
          //             classes: "col-md-6",
          //             label: "message.contracts.sad_line_6",
          //           },
          //           {
          //             type: "cleave",
          //             classes: "col-md-6",
          //             id: "gtd_G5",
          //             model: "g05",
          //             label: "message.contracts.gtd_g05",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               cleave: {
          //                 numeral: true,
          //                 numeralPositiveOnly: true,
          //                 blocks: [20],
          //                 numeralDecimalScale: 2,
          //               },
          //             },
          //           },
          //           {
          //             type: "cleave",
          //             classes: "col-md-6",
          //             id: "gtd_G6",
          //             model: "g06",
          //             label: "message.contracts.gtd_g06",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               cleave: {
          //                 numeral: true,
          //                 numeralPositiveOnly: true,
          //                 blocks: [20],
          //                 numeralDecimalScale: 2,
          //               },
          //             },
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         id: "col-03",
          //         classes: "col-md-6  mt-3",
          //         items: [
          //           {
          //             type: "h",
          //             classes: "col-md-12",
          //             id: "h-004",
          //             label: "message.contracts.sad_line_7",
          //           },
          //           {
          //             type: "v-select",
          //             id: "gtd_gk_7",
          //             required: true,
          //             model: "gk_7",
          //             classes: "col-12",
          //             label: "message.contracts.gtd_gk_7",
          //             is_filled: true,
          //             is_required: true,
          //             options: {
          //               request: "features_goods_decl",
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   {
          //     classes: "row mt-2",
          //     id: "row-2",
          //     items: [
          //       {
          //         type: "col",
          //         id: "col-4",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             id: "h-2",
          //             label: "message.contracts.sad_line_8",
          //             type: "h",
          //             classes: "col-12",
          //             is_filled: false,
          //           },
          //           {
          //             type: "text",
          //             id: "gtd_g081",
          //             classes: "col-md-6",
          //             model: "g081",
          //             label: "message.contracts.gtd_g081",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               maxlength: 20,
          //             },
          //           },
          //           {
          //             type: "text",
          //             id: "gtd_g082",
          //             classes: "col-md-6",
          //             model: "g082",
          //             label: "message.contracts.gtd_g082",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               maxlength: 200,
          //               labelclass: "two-line",
          //             },
          //           },
          //           {
          //             type: "address",
          //             classes: "col-md-12",
          //             id: "gtd_g083",
          //             model: "g083",
          //             label: "message.contracts.gtd_g083",
          //             is_filled: true,
          //             is_required: false,
          //             options: {},
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         id: "col-5",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             id: "h-2",
          //             label: "message.contracts.sad_line_8",
          //             type: "h",
          //             classes: "col-12 text-white",
          //             is_filled: false,
          //           },
          //           {
          //             type: "v-select",
          //             id: "gtd_g11",
          //             required: true,
          //             classes: "col-md-12",
          //             model: "g11",
          //             label: "message.contracts.gtd_g11",
          //             is_filled: true,
          //             is_required: true,
          //             options: {
          //               request: "country",
          //             },
          //           },
          //           {
          //             type: "cleave",
          //             id: "gtd_g12",
          //             classes: "col-md-12",
          //             model: "g12",
          //             label: "message.contracts.gtd_g12",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               cleave: {
          //                 numeral: true,
          //                 numeralPositiveOnly: true,
          //                 blocks: [20],
          //                 numeralDecimalScale: 2,
          //               },
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   {
          //     id: "row-3",
          //     items: [
          //       {
          //         type: "col",
          //         id: "col-6",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             type: "h",
          //             id: "h14",
          //             classes: "col-md-12",
          //             label: "message.contracts.sad_line_14",
          //           },
          //           {
          //             id: "gtd_g0141",
          //             model: "g0141",
          //             type: "text",
          //             classes: "col-md-6",
          //             label: "message.contracts.gtd_g0141",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               maxlength: 20,
          //             },
          //           },
          //           {
          //             id: "gtd_g0142",
          //             model: "g0142",
          //             type: "text",
          //             classes: "col-md-6",
          //             label: "message.contracts.gtd_g0142",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               maxlength: 200,
          //               labelclass: "two-line",
          //             },
          //           },
          //           {
          //             id: "gtd_g0143",
          //             model: "g0143",
          //             type: "address",
          //             classes: "col-md-12",
          //             label: "message.contracts.gtd_g0143",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               maxlength: 200,
          //             },
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         id: "col-7",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             type: "h",
          //             classes: "col-md-12 text-white",
          //             label: "message.contracts.sad_line_14",
          //           },
          //           {
          //             type: "v-select",
          //             id: "gtd_g116a",
          //             classes: "col-md-12",
          //             model: "g16a",
          //             required: true,
          //             label: "message.contracts.gtd_g16a",
          //             is_filled: true,
          //             is_required: true,
          //             options: {
          //               request: "country",
          //             },
          //           },
          //           {
          //             type: "v-select",
          //             id: "gtd_g15a",
          //             required: true,
          //             classes: "col-md-6",
          //             model: "g15a",
          //             label: "message.contracts.gtd_g15a",
          //             is_filled: true,
          //             is_required: true,
          //             options: {
          //               request: "country",
          //             },
          //           },
          //           {
          //             type: "v-select",
          //             id: "gtd_g17a",
          //             required: true,
          //             classes: "col-md-6",
          //             model: "g17a",
          //             label: "message.contracts.gtd_g17a",
          //             is_filled: true,
          //             is_required: true,
          //             options: {
          //               request: "country",
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   {
          //     id: "row-5",
          //     items: [
          //       {
          //         type: "col",
          //         id: "col-9",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             type: "switch",
          //             id: "gtd_g19",
          //             model: "g19",
          //             classes: "col-md-5",
          //             label: "message.contracts.gtd_g19",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               choice_1: "message.no",
          //               choice_2: "message.yes",
          //             },
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         id: "col-10",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             type: "h",
          //             id: "h-13",
          //             label: "message.contracts.sad_line_20",
          //             classes: "col-md-12",
          //           },
          //           {
          //             id: "gtd_g20",
          //             model: "g20",
          //             type: "cleave",
          //             classes: "col-md-6",
          //             label: "message.contracts.gtd_g20",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               cleave: {
          //                 numeral: true,
          //                 numeralPositiveOnly: true,
          //                 blocks: [20],
          //                 numeralDecimalScale: 2,
          //               },
          //             },
          //           },
          //           {
          //             id: "gtd_g20_incoterms",
          //             type: "v-select",
          //             model: "g20_incoterms",
          //             label: "message.contracts.gtd_g20_incoterms",
          //             classes: "col-md-6",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               request: "delivery_term",
          //             },
          //           },
          //           {
          //             id: "gtd_g20_place",
          //             label: "message.contracts.gtd_g20_place",
          //             model: "g20_place",
          //             type: "text",
          //             classes: "col-md-12",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               maxlength: 200,
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   {
          //     id: "row-7",
          //     items: [
          //       {
          //         type: "col",
          //         id: "col-11",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             type: "h",
          //             id: "h-11",
          //             label: "message.contracts.sad_line_21",
          //             classes: "col-md-12",
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         id: "col-12",
          //         classes: "col-md-3",
          //         items: [
          //           {
          //             type: "h",
          //             id: "h-10",
          //             label: "message.contracts.sad_line_22",
          //             classes: "col-md-12",
          //           },
          //           {
          //             type: "v-select",
          //             label: "message.contracts.gtd_g22_curr",
          //             classes: "col-md-12",
          //             id: "gtd_g22_curr",
          //             model: "g22_curr",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               request: "currency",
          //             },
          //           },
          //           {
          //             type: "cleave",
          //             id: "gtd_gtd_total_price",
          //             model: "gtd_total_price",
          //             label: "message.contracts.gtd_gtd_total_price",
          //             classes: "col-md-12",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               labelclass: "two-line",
          //               cleave: {
          //                 numeral: true,
          //                 numeralPositiveOnly: true,
          //                 blocks: [20],
          //                 numeralDecimalScale: 2,
          //               },
          //             },
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         id: "col-13",
          //         classes: "col-md-3",
          //         items: [
          //           {
          //             type: "h",
          //             id: "h-18",
          //             label: "message.contracts.sad_line_23",
          //             classes: "col-md-12",
          //           },
          //           {
          //             type: "cleave",
          //             id: "gtd_g23",
          //             model: "g23",
          //             label: "message.contracts.gtd_g23",
          //             classes: "col-md-12",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               readonly: true,
          //               cleave: {
          //                 numeral: true,
          //                 numeralPositiveOnly: true,
          //                 blocks: [20],
          //                 numeralDecimalScale: 2,
          //               },
          //             },
          //           },
          //           {
          //             type: "h",
          //             id: "h-19",
          //             classes: "col-md-12",
          //             label: "message.contracts.sad_line_24",
          //           },
          //           {
          //             type: "v-select",
          //             id: "gtd_g241",
          //             model: "g241",
          //             classes: "col-md-12",
          //             label: "message.contracts.gtd_g241",
          //             is_filled: true,
          //             is_required: true,
          //             options: {
          //               request: "nature_of_transaction",
          //             },
          //           },
          //           {
          //             type: "v-select",
          //             id: "gtd_g221",
          //             model: "g242",
          //             classes: "col-md-12",
          //             label: "message.contracts.gtd_g242",
          //             is_filled: true,
          //             is_required: true,
          //             options: {
          //               request: "attis_payment_types",
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   {
          //     id: "row-8",
          //     items: [
          //       {
          //         type: "col",
          //         classes: "col-md-6",
          //         id: "col-14",
          //         items: [
          //           {
          //             type: "h",
          //             id: "h-21",
          //             classes: "col-md-12",
          //             label:
          //               "25. Вид транспорта / 26. Вид транспорта / 27. Место погрузки-разгрузки",
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         classes: "col-md-6",
          //         id: "col-15",
          //         items: [
          //           {
          //             type: "h",
          //             id: "h-22",
          //             classes: "col-md-12",
          //             label: "28. Финансовые и банковские сведения",
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   {
          //     id: "row-9",
          //     items: [
          //       {
          //         type: "col",
          //         id: "col-16",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             type: "h",
          //             id: "h-23",
          //             classes: "col-md-12",
          //             label: "29. Орган въезда/выезда",
          //           },
          //         ],
          //       },
          //       {
          //         type: "col",
          //         id: "col-17",
          //         classes: "col-md-6",
          //         items: [
          //           {
          //             type: "v-select",
          //             id: "gtd_g30_place",
          //             label: "message.contracts.gtd_g30_place",
          //             model: "g30_place",
          //             classes: "col-md-12",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               request: "goods_places",
          //             },
          //           },
          //           {
          //             type: "v-select",
          //             id: "gtd_g30_twh_code",
          //             classes: "col-md-12",
          //             label: "message.contracts.gtd_g30_twh_code",
          //             model: "g30_twh_code",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               request: "customs_office",
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   {
          //     type: "row",
          //     id: "row-10-1",
          //     items: [
          //       {
          //         type: "product-repeater",
          //         id: "product-repeater-1",
          //         classes: "col-md-12",
          //         items: [
          //           {
          //             id: "row-10",
          //             items: [
          //               {
          //                 type: "col",
          //                 id: "col-18",
          //                 classes: "col-md-6",
          //                 items: [
          //                   {
          //                     type: "h",
          //                     id: "h-23",
          //                     classes: "col-md-12",
          //                     label: "message.contracts.sad_line_31",
          //                   },
          //                   {
          //                     type: "text",
          //                     id: "gtd_g31_good_name",
          //                     label: "message.contracts.gtd_g31_good_name",
          //                     model: "g31_good_name",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {},
          //                   },
          //                   {
          //                     type: "text",
          //                     id: "gtd_g31_good_rec",
          //                     label: "message.contracts.gtd_g31_good_rec",
          //                     model: "g31_good_rec",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {},
          //                   },
          //                   {
          //                     type: "text",
          //                     id: "gtd_g31_good_data",
          //                     label: "message.contracts.gtd_g31_good_data",
          //                     model: "g31_good_data",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {},
          //                   },
          //                   {
          //                     type: "cleave",
          //                     id: "gtd_g31_cti",
          //                     model: "g31_cti",
          //                     classes: "col-md-6",
          //                     label: "message.contracts.gtd_g31_cti",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       labelclass: "two-line",
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "gtd_gr31_measure",
          //                     model: "gr31_measure",
          //                     label: "message.contracts.gtd_gr31_measure",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: true,
          //                     options: {
          //                       request: "measure",
          //                     },
          //                   },
          //                   {
          //                     type: "cleave",
          //                     label: "message.contracts.gtd_gr31_place_quant",
          //                     id: "gr31_place_quant",
          //                     model: "gr31_place_quant",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "gtd_g31_place_type",
          //                     classes: "col-md-12",
          //                     label: "message.contracts.gtd_g31_place_type",
          //                     model: "g31_place_type",
          //                     is_filled: true,
          //                     is_required: true,
          //                     options: {
          //                       request: "packaging",
          //                     },
          //                   },
          //                   {
          //                     type: "cleave",
          //                     label:
          //                       "message.contracts.gtd_g31_container_quant",
          //                     model: "g31_container_quant",
          //                     id: "g31_container_quant",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       labelclass: "two-line",
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "text",
          //                     label:
          //                       "message.contracts.gtd_g31_proc_conditions",
          //                     id: "g31_proc_conditions",
          //                     model: "g31_proc_conditions",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {},
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "mark_pv",
          //                     model: "g31_mark",
          //                     label: "message.contracts.gtd_g31_mark",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "",
          //                       indata: [
          //                         {
          //                           value: "pv",
          //                           display_text:
          //                             "message.contracts.gtd_g31_mark_pv",
          //                         },
          //                       ],
          //                     },
          //                   },
          //                   {
          //                     type: "cleave",
          //                     id: "g31_check_mark",
          //                     label: "message.contracts.gtd_g31_check_mark",
          //                     model: "g31_check_mark",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       labelclass: "two-line",
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                 ],
          //               },
          //               {
          //                 type: "col",
          //                 classes: "col-md-6",
          //                 id: "col-19",
          //                 items: [
          //                   {
          //                     type: "h",
          //                     id: "h-25",
          //                     label: "message.contracts.sad_line_32",
          //                     classes: "col-md-12",
          //                   },
          //                   {
          //                     type: "cleave",
          //                     classes: "col-md-12",
          //                     id: "g32_good_num",
          //                     model: "g32_good_num",
          //                     label: "message.contracts.gtd_g32_good_num",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       autoload: `(column, index, product)=>{
					// 											return product.g32_good_num
					// 										}`,
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "h",
          //                     id: "h-26",
          //                     label: "message.contracts.sad_line_33",
          //                     classes: "col-md-12",
          //                   },
          //                   {
          //                     type: "tnved",
          //                     label: "message.contracts.gtd_g33_tnved",
          //                     id: "gtd_g33_tnved",
          //                     classes: "col-md-12",
          //                     model: "g33_tnved",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       name: "message.tnved_name",
          //                       code: "message.tnved_code",
          //                     },
          //                   },
          //                   {
          //                     type: "h",
          //                     id: "h-27",
          //                     label: "message.contracts.sad_line_36",
          //                     classes: "col-md-12 mt-2",
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g36_1",
          //                     model: "g36_1",
          //                     label: "message.contracts.gtd_g36_1",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "cust_dutes_benefits",
          //                     },
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g36_2",
          //                     model: "g36_2",
          //                     label: "message.contracts.gtd_g36_2",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "cust_dutes_benefits",
          //                     },
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g36_3",
          //                     model: "g36_3",
          //                     label: "message.contracts.gtd_g36_3",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "excise_dutes_benefits",
          //                     },
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g36_4",
          //                     model: "g36_4",
          //                     label: "message.contracts.gtd_g36_4",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "vat_benefits",
          //                     },
          //                   },
          //                   {
          //                     type: "h",
          //                     id: "h-28",
          //                     label: "message.contracts.sad_line_37",
          //                     classes: "col-md-12",
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g37_cust_rej_code",
          //                     model: "g37_cust_rej_code",
          //                     label: "message.contracts.gtd_g37_cust_rej_code",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "cust_rej",
          //                     },
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g37_good_movement_features_code",
          //                     model: "g37_good_movement_features_code",
          //                     label:
          //                       "message.contracts.gtd_g37_good_movement_features_code",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "goods_movement_features",
          //                     },
          //                   },
          //                   {
          //                     type: "h",
          //                     id: "h-29",
          //                     label: "message.contracts.sad_line_39",
          //                     classes: "col-md-12",
          //                   },
          //                   {
          //                     type: "cleave",
          //                     classes: "col-md-6",
          //                     label: "message.contracts.gtd_g39_quota",
          //                     model: "g39_quota",
          //                     id: "g39_quota",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g39_quota_rest_measure",
          //                     model: "g39_quota_rest_measure",
          //                     label:
          //                       "message.contracts.gtd_g39_quota_rest_measure",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "measure",
          //                     },
          //                   },
          //                   {
          //                     type: "cleave",
          //                     classes: "col-md-6",
          //                     label: "message.contracts.gtd_g39_quota_rest",
          //                     model: "g39_quota_rest",
          //                     id: "g39_quota_rest",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g39_quota_rest_measure",
          //                     model: "g39_quota_rest_measure",
          //                     label:
          //                       "message.contracts.gtd_g39_quota_rest_measure",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "measure",
          //                     },
          //                   },
          //                   {
          //                     type: "h",
          //                     id: "h-28",
          //                     classes: "col-md-12",
          //                     label: "message.contracts.sad_line_40",
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g40_doc_code",
          //                     model: "g40_doc_code",
          //                     label: "message.contracts.gtd_g40_doc_code",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "gtd_doc_codes",
          //                     },
          //                   },
          //                   {
          //                     type: "text",
          //                     id: "g40_doc_num",
          //                     model: "g40_doc_num",
          //                     label: "message.contracts.gtd_g40_doc_num",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       labelclass: "two-line",
          //                     },
          //                   },
          //                   {
          //                     type: "datepicker",
          //                     id: "g40_doc_date",
          //                     model: "g40_doc_date",
          //                     label: "message.contracts.gtd_g40_doc_date",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       labelclass: "two-line",
          //                     },
          //                   },
          //                   {
          //                     type: "cleave",
          //                     id: "g40_weight_netto",
          //                     model: "g40_weight_netto",
          //                     label: "message.contracts.gtd_g40_weight_netto",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "cleave",
          //                     id: "g40_quantity",
          //                     model: "g40_quantity",
          //                     label: "message.contracts.gtd_g40_quantity",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "v-select",
          //                     id: "g40_measure",
          //                     model: "g40_measure",
          //                     label: "message.contracts.gtd_g40_measure",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       request: "measure",
          //                       labelclass: "two-line",
          //                     },
          //                   },
          //                   {
          //                     type: "tnved",
          //                     id: "g40_hs_code",
          //                     model: "g40_hs_code",
          //                     label: "message.contracts.gtd_g40_hs_code",
          //                     classes: "col-md-12",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       code: "message.tnved_code",
          //                       name: "message.tnved_name",
          //                     },
          //                   },
          //                   {
          //                     type: "cleave",
          //                     id: "g40_cost",
          //                     model: "g40_cost",
          //                     label: "message.contracts.gtd_g40_cost",
          //                     classes: "col-md-4 mt-3 pr-0",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "cleave",
          //                     id: "g40_rate_a",
          //                     model: "g40_rate_a",
          //                     label: "message.contracts.gtd_g40_rate_a",
          //                     classes: "col-md-4 mt-3 pr-0",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "cleave",
          //                     id: "g40_vat",
          //                     model: "g40_vat",
          //                     label: "message.contracts.gtd_g40_vat",
          //                     classes: "col-md-4 mt-3",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                 ],
          //               },
          //             ],
          //           },
          //           {
          //             classes: "row",
          //             items: [
          //               {
          //                 type: "col",
          //                 classes: "col-md-12",
          //                 id: "col-20",
          //                 items: [
          //                   {
          //                     type: "text",
          //                     classes: "col-md-4",
          //                     id: "gtd_g41",
          //                     model: "g41",
          //                     label: "message.contracts.gtd_g41",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {},
          //                   },
          //                   {
          //                     type: "cleave",
          //                     classes: "col-md-4",
          //                     id: "gtd_g41",
          //                     model: "g42",
          //                     label: "message.contracts.gtd_g42",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                   {
          //                     type: "text",
          //                     classes: "col-md-4",
          //                     id: "gtd_g41",
          //                     model: "g43",
          //                     label: "message.contracts.gtd_g43",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {},
          //                   },
          //                 ],
          //               },
          //             ],
          //           },
          //           {
          //             classes: "row",
          //             items: [
          //               {
          //                 type: "col",
          //                 classes: "col-md-12",
          //                 id: "col-12-g44",
          //                 items: [
          //                   {
          //                     type: "h",
          //                     id: "h-g44",
          //                     label: "message.contracts.sad_line_44",
          //                     classes: "col-md-12",
          //                   },
          //                   {
          //                     type: "table",
          //                     classes: "col-md-12",
          //                     id: "g44",
          //                     model: "g44",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       is_in_product: true,
          //                       columns: [
          //                         {
          //                           type: "cleave",
          //                           id: "g32_good_num-grid",
          //                           label:
          //                             "message.contracts.gtd_g44_g32_good_num",
          //                           model: "g32_good_num",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {
          //                             autoload: `(column, index, product)=>{
					// 														return product.g32_good_num
					// 													}`,
          //                             cleave: {
          //                               numeral: true,
          //                               numeralPositiveOnly: true,
          //                               blocks: [20],
          //                               numeralDecimalScale: 2,
          //                             },
          //                           },
          //                         },
          //                         {
          //                           type: "v-select",
          //                           id: "g44_doc_type_code",
          //                           model: "g44_doc_type_code",
          //                           label:
          //                             "message.contracts.gtd_g44_g44_doc_type_code",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {
          //                             request: "gtd_doc_codes",
          //                           },
          //                         },
          //                         {
          //                           type: "text",
          //                           id: "g44_serial_doc_num",
          //                           model: "g44_serial_doc_num",
          //                           label:
          //                             "message.contracts.gtd_g44_serial_doc_num",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {
          //                             autoload: `(field, index)=>{
					// 														return index+1
					// 													}`,
          //                           },
          //                         },
          //                         {
          //                           type: "text",
          //                           id: "g44_doc_num",
          //                           model: "g44_doc_num",
          //                           label: "message.contracts.gtd_g44_doc_num",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {},
          //                         },
          //                         {
          //                           type: "datepicker",
          //                           id: "g44_doc_date",
          //                           model: "g44_doc_date",
          //                           label: "message.contracts.gtd_g44_doc_date",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {},
          //                         },
          //                         {
          //                           type: "datepicker",
          //                           id: "g44_doc_reg_nun",
          //                           model: "g44_doc_reg_nun",
          //                           label:
          //                             "message.contracts.gtd_g44_doc_reg_nun",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {},
          //                         },
          //                         {
          //                           type: "datepicker",
          //                           id: "g44_doc_begin_date",
          //                           model: "g44_doc_begin_date",
          //                           label:
          //                             "message.contracts.gtd_g44_doc_begin_date",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {},
          //                         },
          //                         {
          //                           type: "datepicker",
          //                           id: "g44_doc_end_date",
          //                           model: "g44_doc_end_date",
          //                           label:
          //                             "message.contracts.gtd_g44_doc_end_date",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {},
          //                         },
          //                         {
          //                           type: "v-select",
          //                           id: "g44_doc_sign",
          //                           model: "g44_doc_sign",
          //                           label: "message.contracts.gtd_g44_doc_sign",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {
          //                             indata: [
          //                               {
          //                                 value: 0,
          //                                 display_text:
          //                                   "message.contracts.gtd_g44_doc_sign_0",
          //                               },
          //                               {
          //                                 value: 1,
          //                                 display_text:
          //                                   "message.contracts.gtd_g44_doc_sign_1",
          //                               },
          //                               {
          //                                 value: 2,
          //                                 display_text:
          //                                   "message.contracts.gtd_g44_doc_sign_2",
          //                               },
          //                               {
          //                                 value: 3,
          //                                 display_text:
          //                                   "message.contracts.gtd_g44_doc_sign_3",
          //                               },
          //                             ],
          //                           },
          //                         },
          //                       ],
          //                     },
          //                   },
          //                 ],
          //               },
          //             ],
          //           },
          //           {
          //             classes: "row",
          //             items: [
          //               {
          //                 type: "col",
          //                 classes: "col-md-6",
          //                 items: [
          //                   {
          //                     type: "h",
          //                     id: "h-1232",
          //                     classes: "col-md-12",
          //                     label: "message.contracts.sad_line_45",
          //                   },
          //                   {
          //                     type: "cleave",
          //                     classes: "col-md-12",
          //                     id: "g45_customs_value",
          //                     model: "g45_customs_value",
          //                     label: "message.contracts.gtd_g45_customs_value",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                 ],
          //               },
          //               {
          //                 type: "col",
          //                 classes: "col-md-6",
          //                 items: [
          //                   {
          //                     type: "h",
          //                     id: "h-1233",
          //                     classes: "col-md-12",
          //                     label: "message.contracts.sad_line_46",
          //                   },
          //                   {
          //                     type: "cleave",
          //                     classes: "col-md-12",
          //                     id: "g46_stat_value",
          //                     model: "g46_stat_value",
          //                     label: "message.contracts.gtd_g46_stat_value",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       cleave: {
          //                         numeral: true,
          //                         numeralPositiveOnly: true,
          //                         blocks: [20],
          //                         numeralDecimalScale: 2,
          //                       },
          //                     },
          //                   },
          //                 ],
          //               },
          //             ],
          //           },
          //           {
          //             classes: "row",
          //             items: [
          //               {
          //                 type: "col",
          //                 classes: "col-md-12",
          //                 id: "col-12-g47",
          //                 items: [
          //                   {
          //                     type: "h",
          //                     id: "h-g47",
          //                     label: "message.contracts.sad_line_47",
          //                     classes: "col-md-12",
          //                   },
          //                   {
          //                     type: "table",
          //                     classes: "col-md-12",
          //                     id: "g47",
          //                     model: "g47",
          //                     is_filled: true,
          //                     is_required: false,
          //                     options: {
          //                       is_in_product: true,
          //                       columns: [
          //                         {
          //                           type: "v-select",
          //                           id: "g47_cust_pay_code",
          //                           label:
          //                             "message.contracts.gtd_g47_cust_pay_code",
          //                           model: "g47_cust_pay_code",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {
          //                             request: "g47_cust_payments",
          //                           },
          //                         },
          //                         {
          //                           type: "text",
          //                           id: "g47_accrual_basis",
          //                           model: "g47_accrual_basis",
          //                           label:
          //                             "message.contracts.gtd_g47_accrual_basis",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {},
          //                         },
          //                         {
          //                           type: "text",
          //                           id: "g47_bet_size",
          //                           model: "g47_bet_size",
          //                           label: "message.contracts.gtd_g47_bet_size",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {},
          //                         },
          //                         {
          //                           type: "v-select",
          //                           id: "g47_bet_measure",
          //                           model: "g47_bet_measure",
          //                           label:
          //                             "message.contracts.gtd_g47_bet_measure",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {
          //                             indata: [
          //                               {
          //                                 value: "percent",
          //                                 display_text: "%",
          //                               },
          //                               {
          //                                 value: "currency",
          //                                 display_text:
          //                                   "message.contracts.gtd_g47_bet_measure_currency",
          //                               },
          //                             ],
          //                           },
          //                         },
          //                         {
          //                           type: "cleave",
          //                           id: "g47_payment_sum",
          //                           model: "g47_payment_sum",
          //                           label:
          //                             "message.contracts.gtd_g47_payment_sum",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {
          //                             cleave: {
          //                               numeral: true,
          //                               numeralPositiveOnly: true,
          //                               blocks: [20],
          //                               numeralDecimalScale: 2,
          //                             },
          //                           },
          //                         },
          //                         {
          //                           type: "v-select",
          //                           id: "g47_pcf_cofe",
          //                           model: "g47_pcf_cofe",
          //                           label: "message.contracts.gtd_g47_pcf_cofe",
          //                           classes: "col-md-12",
          //                           is_filled: true,
          //                           is_required: false,
          //                           options: {
          //                             request: "currency",
          //                           },
          //                         },
          //                       ],
          //                     },
          //                   },
          //                   {
          //                     type: "h",
          //                     id: "h-g48",
          //                     label: "message.contracts.sad_line_48",
          //                     classes: "col-md-12",
          //                   },
          //                   {
          //                     type: "table",
          //                     classes: "col-md-12",
          //                     id: "g48",
          //                     model: "g48",
          //                     options: {
          //                       is_in_product: true,
          //                       columns: [
          //                         {
          //                           type: "v-select",
          //                           id: "g48_cust_pay_code",
          //                           label:
          //                             "message.contracts.gtd_g48_cust_pay_code",
          //                           model: "g48_cust_pay_code",
          //                           classes: "col-md-12",
          //                           options: {
          //                             request: "g47_cust_payments",
          //                           },
          //                         },
          //                         {
          //                           type: "text",
          //                           id: "g48_doc_number",
          //                           model: "g48_doc_number",
          //                           label:
          //                             "message.contracts.gtd_g48_doc_number",
          //                           classes: "col-md-12",
          //                           options: {
          //                             autoload: `(field, index)=>{
					// 														return index+1
					// 													}`,
          //                           },
          //                         },
          //                         {
          //                           type: "datepicker",
          //                           id: "g48_doc_date",
          //                           model: "g48_doc_date",
          //                           label: "message.contracts.gtd_g48_doc_date",
          //                           classes: "col-md-12",
          //                           options: {},
          //                         },
          //                         {
          //                           type: "datepicker",
          //                           id: "g48_payment_date",
          //                           model: "g48_payment_date",
          //                           label:
          //                             "message.contracts.gtd_g48_payment_date",
          //                           classes: "col-md-12",
          //                           options: {},
          //                         },
          //                       ],
          //                     },
          //                   },
          //                   {
          //                     type: "h",
          //                     classes: "col-md-12",
          //                     id: "h-g54",
          //                     label: "message.contracts.sad_line_54",
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g541_doc_num",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g541_doc_num",
          //                     options: {
          //                       description:
          //                         "message.contracts.gtd_g541_doc_num_desc",
          //                     },
          //                   },
          //                   {
          //                     type: "datepicker",
          //                     model: "g541_doc_date",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g541_doc_date",
          //                     options: {
          //                       description:
          //                         "message.contracts.gtd_g541_doc_date_desc",
          //                     },
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g541_contract_num",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g541_contract_num",
          //                     options: {
          //                       description:
          //                         "message.contracts.gtd_g541_contract_num_desc",
          //                     },
          //                   },
          //                   {
          //                     type: "datepicker",
          //                     model: "g541_contract_date",
          //                     classes: "col-md-6",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g541_contract_date",
          //                     options: {
          //                       description:
          //                         "message.contracts.gtd_g541_contract_date_desc",
          //                     },
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g542_surname",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g542_surname",
          //                     options: {},
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g542_name",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g542_name",
          //                     options: {},
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g542_midlname",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g542_midlname",
          //                     options: {},
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g542_position",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g542_position",
          //                     options: {},
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g542_phone",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g542_phone",
          //                     options: {},
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g542_cert",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g542_cert",
          //                     options: {
          //                       description:
          //                         "message.contracts.gtd_g542_cert_desc",
          //                     },
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g542_doctype",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g542_doctype",
          //                     options: {},
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g542_pass_num",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g542_pass_num",
          //                     options: {},
          //                   },
          //                   {
          //                     type: "datepicker",
          //                     model: "g542_pass_date",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label: "message.contracts.gtd_g542_pass_date",
          //                     options: {},
          //                   },
          //                   {
          //                     type: "text",
          //                     model: "g543_powers_doc_num",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label:
          //                       "message.contracts.gtd_g543_powers_doc_num",
          //                     options: {
          //                       description:
          //                         "message.contracts.gtd_g543_powers_doc_num_desc",
          //                     },
          //                   },
          //                   {
          //                     type: "datepicker",
          //                     model: "g543_powers_doc_date",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label:
          //                       "message.contracts.gtd_g543_powers_doc_date",
          //                     options: {
          //                       description:
          //                         "message.contracts.gtd_g543_powers_doc_date_desc",
          //                     },
          //                   },
          //                   {
          //                     type: "datepicker",
          //                     model: "g543_powers_doc_date_end",
          //                     classes: "col-md-4",
          //                     is_filled: true,
          //                     is_required: false,
          //                     label:
          //                       "message.contracts.gtd_g543_powers_doc_date_end",
          //                     options: {},
          //                   },
          //                 ],
          //               },
          //             ],
          //           },
          //         ],
          //       },
          //     ],
          //   },
          //   {
          //     type: "row",
          //     items: [
          //       {
          //         type: "col",
          //         classes: "col-md-12",
          //         id: "col-grb",
          //         items: [
          //           {
          //             type: "h",
          //             label: "message.contracts.sad_line_b",
          //             classes: "col-md-12",
          //             id: "h-grb",
          //           },
          //           {
          //             type: "table",
          //             classes: "col-md-12",
          //             id: "gb",
          //             model: "gb",
          //             is_filled: true,
          //             is_required: false,
          //             options: {
          //               columns: [
          //                 {
          //                   type: "v-select",
          //                   id: "g47_cust_payment",
          //                   label: "message.contracts.gtd_gb_g47_cust_payment",
          //                   model: "g47_cust_payment",
          //                   classes: "col-md-12",
          //                   is_filled: true,
          //                   is_required: false,
          //                   options: {
          //                     request: "g47_cust_payments",
          //                   },
          //                 },
          //                 {
          //                   type: "cleave",
          //                   classes: "col-md-12",
          //                   id: "payment_sum",
          //                   model: "payment_sum",
          //                   label: "message.contracts.gtd_gb_payment_sum",
          //                   is_filled: true,
          //                   is_required: false,
          //                   options: {
          //                     cleave: {
          //                       numeral: true,
          //                       numeralPositiveOnly: true,
          //                       blocks: [20],
          //                       numeralDecimalScale: 2,
          //                     },
          //                   },
          //                 },
          //                 {
          //                   type: "v-select",
          //                   id: "gb_curr_code",
          //                   model: "curr_code",
          //                   label: "message.contracts.gtd_gb_curr_code",
          //                   classes: "col-md-12",
          //                   is_filled: true,
          //                   is_required: false,
          //                   options: {
          //                     request: "currency",
          //                   },
          //                 },
          //                 {
          //                   type: "text",
          //                   id: "payment_order_num",
          //                   model: "payment_order_num",
          //                   label: "message.contracts.gtd_gb_payment_order_num",
          //                   classes: "col-md-12",
          //                   is_filled: true,
          //                   is_required: false,
          //                   options: {},
          //                 },
          //                 {
          //                   type: "datepicker",
          //                   id: "payment_order_date",
          //                   model: "payment_order_date",
          //                   label:
          //                     "message.contracts.gtd_gb_payment_order_date",
          //                   classes: "col-md-12",
          //                   is_filled: true,
          //                   is_required: false,
          //                   options: {},
          //                 },
          //                 {
          //                   type: "v-select",
          //                   id: "payment_methods",
          //                   model: "payment_methods",
          //                   label: "message.contracts.gtd_gb_payment_methods",
          //                   classes: "col-md-12",
          //                   is_filled: true,
          //                   is_required: false,
          //                   options: {
          //                     request: "payment_methods",
          //                   },
          //                 },
          //                 {
          //                   type: "text",
          //                   id: "gb_company_id",
          //                   model: "company_id",
          //                   label: "message.contracts.gtd_gb_company_id",
          //                   classes: "col-md-12",
          //                   is_filled: true,
          //                   is_required: false,
          //                   options: {},
          //                 },
          //               ],
          //             },
          //           },
          //         ],
          //       },
          //     ],
          //   },
          // ],
        },
      };
    },
    edit(index) {
      this.current_form.data = this.forms[index].form_data;
      this.current_form.type = this.forms[index].form_type;
      this.is_add_edit = true;
    },
    create() {
      let formdata = new FormData();
      formdata.append("form_type", this.current_form.type);
      formdata.append("form_data", JSON.stringify(this.current_form.data));
      axios
        .post(window.base + "/document/create_sad_template", formdata)
        .then((response) => {
          if (response.data.success == true) {
            this.current_form = {
              type: "",
              data: {
                items: [],
              },
            };
            this.is_add_edit = false;
            this.is_new = false;
            this.load();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: response.data.message,
              timeout: 5000,
            }).show();
          }
        });
    },
    save() {
      let formdata = new FormData();
      formdata.append("form_type", this.current_form.type);
      formdata.append("form_data", JSON.stringify(this.current_form.data));
      axios
        .post(
          window.base +
            "/document/update_sad_template?document_id=" +
            this.current_form.id,
          formdata,
        )
        .then((response) => {
          if (response.data.success == true) {
            this.current_form = {
              type: "",
              data: {
                items: [],
              },
            };
            this.is_add_edit = false;
            this.load();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: response.data.message,
              timeout: 5000,
            }).show();
          }
        });
    },
    remove(id) {
      axios
        .get(window.base + "/document/delete_sad_template?document_id=" + id)
        .then((response) => {
          if (response.data.success == true) {
            this.load();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: response.data.message,
              timeout: 5000,
            }).show();
          }
        });
    },
  },
};
</script>
<style>
.column-handle,
.field-handle {
  cursor: grab;
}
</style>
